// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__vssTe","loader":"styles_loader__kYl4Q"};